import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from "./ui/dropdown-menu";
import { Bell } from "lucide-react";

export default function NotificationsBell() {
  const [notifs, setNotifs] = useState([]);
  const [unread, setUnread] = useState(0);
  const [open, setOpen] = useState(false);

  const load = useCallback(async () => {
    try {
      const r = await api.get("/notifications");
      setNotifs(r.data.notifications || []);
      setUnread(r.data.unread || 0);
    } catch (e) { console.error("notifications load failed", e); }
  }, []);

  useEffect(() => {
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, [load]);

  const markAll = async () => {
    await api.post("/notifications/mark-read", { all: true });
    load();
  };
  const openWithMark = async (n) => {
    if (!n.read) {
      await api.post("/notifications/mark-read", { ids: [n.id] });
      load();
    }
    setOpen(false);
  };

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <button data-testid="notifications-bell" className="relative h-11 w-11 rounded-md hover:bg-neutral-800 grid place-items-center transition-colors">
          <Bell className="h-5 w-5" />
          {unread > 0 && (
            <span data-testid="notif-badge" className="absolute top-1 right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-red-600 text-white text-[10px] font-bold grid place-items-center">
              {unread > 9 ? "9+" : unread}
            </span>
          )}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-80 p-0 bg-neutral-900 border-neutral-800">
        <div className="p-3 border-b border-neutral-800 flex items-center justify-between">
          <div className="font-display-heavy text-sm uppercase tracking-widest">Notifications</div>
          {unread > 0 && <button data-testid="notif-mark-all" onClick={markAll} className="text-xs text-red-500 hover:text-red-400 uppercase tracking-widest">Mark all read</button>}
        </div>
        <div className="max-h-80 overflow-y-auto">
          {notifs.length === 0 ? (
            <div className="p-6 text-center text-neutral-500 text-sm">No notifications yet.</div>
          ) : notifs.map((n) => (
            <Link key={n.id} to="/plan" onClick={() => openWithMark(n)}
              className={`block px-3 py-3 border-b border-neutral-800 hover:bg-neutral-800/50 transition-colors ${!n.read ? "bg-red-950/20" : ""}`}
              data-testid={`notif-item-${n.id}`}>
              <div className="flex items-start gap-2">
                {!n.read && <span className="w-2 h-2 rounded-full bg-red-500 mt-1.5 shrink-0" />}
                <div className="flex-1 min-w-0">
                  <div className="text-sm text-white truncate"><span className="font-semibold">{n.from_user_name}</span> left a note</div>
                  <div className="text-xs text-neutral-400 mt-0.5 line-clamp-2">{n.body_preview}</div>
                  <div className="text-[11px] text-neutral-500 mt-1">{new Date(n.created_at).toLocaleString()}</div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
